module.exports = {
  login: 'Login to view vouchers',
  vouchersTitle: 'Vouchers',
  bookNow: 'New booking with voucher',
  voucherLookup: 'Check voucher',
  voucherRefunded: 'Refunded',
  voucherExpired: 'Expired',
  emailAddress: 'Email address',
  ref: 'Booking / voucher number',
  lookUp: 'Search',
  noVoucher: 'No active voucher was found. Please check your details and try again.',
  requestRefund: 'Request a refund',
  headings: {
    voucher: 'Voucher',
    booking: 'Booking',
    total: 'Total amount',
    redeemed: 'Redeemed',
    balance: 'Balance',
    created: 'Created',
    expiry: 'Expiry date',
    nonFlex: 'Flexible?*'
  },
  types: {
    active: 'Active',
    redeemed: 'Redeemed',
    refunded: 'Refunded',
    expired: 'Expired'
  },
  vouchersFor: 'Vouchers for',
  noVouchersFound: 'Sorry, no vouchers found',
  requestRefund: 'Request voucher refund',
  fullRefundStartFragment: 'If you convert your voucher into a refund, you will receive',
  fullRefundEndFragment: 'back to your payment method within 5 days.',
  refundMyCard: 'Get refund',
  keepMyVoucher: 'Keep my voucher',
  keepMyVoucherForFullAmount: 'Keep voucher for full amount',
  fee: 'receive fee',
  refundMyCardLess: 'Refund minus',
  partialRefundFramentOne: 'If you convert your voucher into a refund, you will receive',
  partialRefundFragmentTwo: 'back to your payment method within 5 days. A processing fee of',
  partialRefundFragmentThree: 'will apply. This will be credited to your customer account. You can use it towards another booking.',
  noRefundvoucher: 'Your voucher can only be converted into a refund within 14 days of cancellation. Your voucher remains valid for all new bookings for the next three years.',
  backToMyVouchers: 'Back to my vouchers',
  noRefundRedeemed: 'Your voucher cannot be converted into a refund as you have already used part of it. The remaining voucher balance remains valid so you can redeem it for another booking.',
  nonFlexNoRefund: 'Your voucher cannot be exchanged for a refund as you did not book a flexible product. You can use your voucher for a new booking for the same product.',
  refundingYourVoucher: 'Voucher refund',
  balance: 'Balance',
  successRefund: 'The voucher has been refunded. The payout may take up to 5 working days.',
  errorRefund: 'Sorry! The voucher cannot be refunded.',
  waitFiveDays: 'The payout may take up to 5 working days.',
  voucherBenefits: 'The Holiday Extras voucher offers you many benefits:',
  benefitOne: 'Your voucher is valid for up to 3 years – giving you plenty of time to plan your holiday.',
  benefitTwo: 'You can redeem the voucher for many Holiday Extras products – treat yourself to a lounge or airport hotel stay, for example.',
  benefitThree: 'You will also receive an exclusive member discount on our parking, hotel and lounge offers.'
}


// WEBPACK FOOTER //
// ./shared/config/components/vouchers/en/index.js